import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import { Checkdevice, Modcfm, Noti, getCroppedImg } from "../../../../../../components";
import { inputdescribe_dom, partialtitle_dom, radiobtn_dom, threebtn_dom } from '../Commonelements/Commonelements';
import { ILOOKUPTEMPLATESINFO_MAP, INVITATION_COUPLE_DEFAULT_IMGS_MAP } from '../../../../../../config/constants';
import { Retrieve_personal_info, getS3fullpath_withbucketname, iconwrapper } from '../../../../../../config/commonfunctions';
import { BLINK_ICON, CROSS_ICON, HEART_PATH, LAPTOP_ICON, TABLET_ICON, WEDO_PATH } from '../../../../../../config/svgicons';
import { S3CLOUD_CLOUDFRONT, S3CLOUD_CLOUDFRONT_ASSET } from '../../../../../../config/s3directories';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { INVITATION_GETIMGUPLOADTOKENS, INVITATION_SAVEHEROIMGS } from '../../../../../../config/api';
import Explain from "../Explain";
import Cropper from 'react-easy-crop';
import axios from 'axios'
import './Heroimages.css'
import { getPresignedUrlWithToken, getPresignedUrlWithTokens, notifyBackendUpload, uploadToS3 } from '../../../../../../config/uploadimgapis';

const TITLE = 'Hero Images'
const TEXT = `Make a strong first impression with the perfect wedding image for your website!`
const colors_arr = ['#333333', '#707070', '#e1d9ca', '#7b5c5c']

const getUniqueThumbnails = (imageMap) => {
    const thumbnailsSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.thumbnail) {
                thumbnailsSet.add(image.thumbnail);
            }
        });
    });
    return Array.from(thumbnailsSet);
};

const getUniqueImgs = (imageMap) => {
    const imgSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.img) {
                imgSet.add(image.img);
            }
        });
    });
    return Array.from(imgSet);
};


const ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS = getUniqueThumbnails(INVITATION_COUPLE_DEFAULT_IMGS_MAP)
const ALL_UNIQUE_DEFAULT_COUPLE_IMGS = getUniqueImgs(INVITATION_COUPLE_DEFAULT_IMGS_MAP)

const blobToImage = (blob) => {
    return new Promise((resolve) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.src = url;
    });
};

const Imagedownsize3x = (img) => {
    const scale = 1 / 3;

    const width = Math.round(img.width * scale);
    const height = Math.round(img.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);

    return canvas.toDataURL('image/jpeg'); // You can change to 'image/png' if needed
};

const Imagedownsize_old = (img, type) => {
    var canvas = document.createElement('canvas');
    var ctx1 = canvas.getContext("2d");
    ctx1.drawImage(img, 0, 0);
    var dataurl
    if (type === 'logo') {
        var MAX_WIDTH = 450;
        var MAX_HEIGHT = 450;
        var width = img.width;
        var height = img.height;

        if (width > height) { // this will adjust in ratio
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx2 = canvas.getContext("2d");
        ctx2.drawImage(img, 0, 0, width, height)
        dataurl = canvas.toDataURL("image/png")
    }
    return dataurl
}

// const dataURLToBlob = function (dataURL) {
//     var BASE64_MARKER = ';base64,';
//     if (dataURL.indexOf(BASE64_MARKER) === -1) {
//         var parts1 = dataURL.split(',');
//         var contentType1 = parts1[0].split(':')[1];
//         var raw1 = parts1[1];
//         return new Blob([raw1], { type: contentType1 });
//     }

//     var parts = dataURL.split(BASE64_MARKER);
//     var contentType = parts[0].split(':')[1];
//     var raw = window.atob(parts[1]);
//     var rawLength = raw.length;

//     var uInt8Array = new Uint8Array(rawLength);

//     for (var i = 0; i < rawLength; ++i) {
//         uInt8Array[i] = raw.charCodeAt(i);
//     }

//     return new Blob([uInt8Array], { type: contentType });
// }

const dataURLToBlob = function (dataURL) {
    const BASE64_MARKER = ';base64,';

    if (!dataURL || typeof dataURL !== 'string') {
        console.error("Invalid dataURL: not a string", dataURL);
        return undefined;
    }

    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        const parts1 = dataURL.split(',');
        if (parts1.length !== 2) {
            console.error("Invalid non-base64 dataURL format", dataURL);
            return undefined;
        }

        const contentType1 = parts1[0].split(':')[1];
        const raw1 = decodeURIComponent(parts1[1]);
        return new Blob([raw1], { type: contentType1 });
    }

    const parts = dataURL.split(BASE64_MARKER);
    if (parts.length !== 2) {
        console.error("Malformed base64 dataURL:", dataURL);
        return undefined;
    }

    const contentType = parts[0].split(':')[1];
    try {
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    } catch (e) {
        console.error("Failed to decode base64:", e, dataURL);
        return undefined;
    }
};

function Singlelayoutbtns(props) { // 1 image
    const { onClick, heroimglayout_map, templatetype, onDelete } = props

    const layout = 'single_' + templatetype
    const isdefaultimg = ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS.includes(heroimglayout_map[layout][0].thumbnail)

    let thumbnail = isdefaultimg
        ? S3CLOUD_CLOUDFRONT_ASSET + 'couple/' + heroimglayout_map[layout][0].thumbnail
        : S3CLOUD_CLOUDFRONT + heroimglayout_map[layout][0].thumbnail
    // : getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', heroimglayout_map[layout][0].thumbnail)

    return <div className='Template_singlelayout' >
        <div className='Template_singlebtnitem'>
            <button
                value={0}
                className='Template_plusbtn'
                onClick={onClick}
                style={{ backgroundImage: 'url(' + thumbnail + ')' }}
            />
            {!isdefaultimg
                ? <button
                    value={0}
                    key={'0singledelete'}
                    className='Template_deleteimg'
                    onClick={() => { onDelete(0) }}
                >
                    {iconwrapper(CROSS_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                </button>
                : null}
        </div>
    </div>
}

function Singlelayoutbtns_old(props) { // 1 image
    const { onClick, heroimglayout_map, templatetype, onDelete } = props
    const layout = 'single_' + templatetype
    const isdefaultimg = ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS.includes(heroimglayout_map[layout][0].thumbnail)

    let thumbnail = isdefaultimg
        ? S3CLOUD_CLOUDFRONT_ASSET + 'couple/' + heroimglayout_map[layout][0].thumbnail
        : S3CLOUD_CLOUDFRONT + heroimglayout_map[layout][0].thumbnail
    // : getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', heroimglayout_map[layout][0].thumbnail)

    return <div className='Template_singlelayout' >
        <div className='Template_singlebtnitem'>
            <button
                value={0}
                className='Template_plusbtn'
                onClick={onClick}
                style={{ backgroundImage: 'url(' + thumbnail + ')' }}
            />
            {!isdefaultimg
                ? <button
                    value={0}
                    key={'0singledelete'}
                    className='Template_deleteimg'
                    onClick={() => { onDelete(0) }}
                >
                    {iconwrapper(CROSS_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                </button>
                : null}
        </div>
    </div>
}

function Marqueelayoutbtns(props) { // 4 images
    const { onClick, heroimglayout_map, templatetype, onDelete } = props;
    const layout = 'marquee_' + templatetype
    return (
        <div className="Template_marqueelayout">
            {Object.values(heroimglayout_map[layout]).map((item, index) => {
                const isdefaultimg = ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS.includes(heroimglayout_map[layout][index].thumbnail)

                let thumbnail = isdefaultimg
                    ? S3CLOUD_CLOUDFRONT_ASSET + 'couple/' + heroimglayout_map[layout][index].thumbnail
                    : S3CLOUD_CLOUDFRONT + heroimglayout_map[layout][index].thumbnail
                // : getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', heroimglayout_map[layout][index].thumbnail)

                // need to ensure thumbnail isnt user uploaded image
                return <div key={'marquee' + index} className='Template_singlebtnitem'>
                    <button
                        key={index + 'marquee'}
                        value={index}
                        className='Template_plusbtn'
                        onClick={onClick}
                        style={{ backgroundImage: 'url(' + thumbnail + ')' }}
                    />
                    {!isdefaultimg
                        ? <button
                            value={index}
                            key={index + 'marqueedelete'}
                            className='Template_deleteimg'
                            onClick={() => { onDelete(index) }}
                        >
                            {iconwrapper(CROSS_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                        </button>
                        : null}
                </div>
            })}
        </div>
    );
}

function Slideshowlayoutbtns(props) { // 2 images
    const { onClick, heroimglayout_map, templatetype, onDelete } = props
    const layout = 'slideshow_' + templatetype
    return (
        <div className="Template_marqueelayout">
            {Object.values(heroimglayout_map[layout]).map((item, index) => {

                const isdefaultimg = ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS.includes(heroimglayout_map[layout][index].thumbnail)

                let thumbnail = isdefaultimg
                    ? S3CLOUD_CLOUDFRONT_ASSET + 'couple/' + heroimglayout_map[layout][index].thumbnail
                    : S3CLOUD_CLOUDFRONT + heroimglayout_map[layout][index].thumbnail
                // : getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', heroimglayout_map[layout][index].thumbnail)

                return <div key={'slideshow' + index} className='Template_singlebtnitem'>
                    <button
                        key={index + 'slideshow'}
                        value={index}
                        className='Template_plusbtn'
                        onClick={onClick}
                        style={{ backgroundImage: 'url(' + thumbnail + ')' }}
                    />
                    {!isdefaultimg
                        ? <button
                            value={index}
                            key={index + 'slideshowdelete'}
                            className='Template_deleteimg'
                            onClick={() => { onDelete(index) }}
                        >
                            {iconwrapper(CROSS_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                        </button>
                        : null}
                </div>
            })}
        </div>
    );
}

function Heroimages(props) {

    const {
        invitation_id,
        urlhandler,
        templatetype,
        heroimglayout,
        updateBackup,
        heroimglayout_map,
        updateHeroimglayout,

        heroimgdevice_map,
        updateHeroimgdevice,

        updateheroimgobj, // add hero img
        delsingleheroimgobj, // delete hero img

        heroimgattr_map,
        updateHeroimgattrmap,

        btmbar,
        showsave,
        setShowsave

    } = props

    const device = Checkdevice()

    const imginputref = useRef(null)
    const [showrmvmod, setShowrmvmod] = useState(false) // toggle rmv modal to qn user
    const [neededit, setNeededit] = useState(false)
    const [selecteddevice, setSelecteddevice] = useState(-1) // 0:WEB || 1:MOBILE
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')
    const [showimgeffect, setShowimgeffect] = useState(false)
    const [heroimgarrposition, setHeroimgarrposition] = useState(-1) // position to be send to backend to indicate the change upload img position

    // for cropping image
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [tempmainaspectratio, setTempmainimgaspectratio] = useState(-1)
    const [tempmainimg, setTempmainimg] = useState(null)
    const [tempmainimginfo, setTempmainimginfo] = useState(null)
    const [tempcroppedimg, setTempcroppedimg] = useState(null)

    // delete image
    const [deleteimgposition, setDeleteimgposition] = useState(-1)
    const [cfmdel, setCfmdel] = useState(false)


    const [uploadstate, setUploadstate] = useState('WAITING') // WAITING, UPLOADING

    const homeimageeffectstyle_commoneditstyle = {
        // height: {
        //     'WEB': 'calc(100% - 70px - 65px)',
        //     'TABLET': 'calc(100% - 70px - 65px)',
        //     'MOBILE': 'calc(100% - 70px)'
        // }[device],
        marginBottom: {
            'MOBILE': 65
        }[device]
    }

    const editupload = async () => {
        setUploadstate('UPLOADING');

        const croppedImage = await getCroppedImg(tempmainimg, tempcroppedimg);

        if (croppedImage) {

            croppedImage.toBlob(async (blob) => {
                // Convert blob to image for resizing
                const image = await blobToImage(blob); // Helper function below
                const downsizedDataUrl = Imagedownsize3x(image); // Shrink by 3x
                const downsizedBlob = dataURLToBlob(downsizedDataUrl); // Convert back to Blob

                const curr_img = new File(
                    [blob],
                    `${urlhandler}.jpg`, // 🔧 force extension to .jpg
                    { type: 'image/jpeg' } // 🔧 force MIME type to image/jpeg
                );

                const curr_thumbnail = new File(
                    [downsizedBlob],
                    `${urlhandler}thumbnail.jpg`, // 🔧 force extension to .jpg
                    { type: 'image/jpeg' } // 🔧 force MIME type to image/jpeg
                );

                uploadtobackend({
                    img: curr_img,
                    thumbnail: curr_thumbnail,
                    urlhandler,
                    id: invitation_id,
                    heroimgarrposition,
                    selectedtemplatetype: templatetype,
                    selectedlayout: heroimglayout
                });

            }, 'image/jpeg');
        }
    };

    const cropcomplete = useCallback((croppedArea, croppedAreaPixels) => {
        setTempcroppedimg(croppedAreaPixels)
    }, [])

    const cropcancel = () => {
        setTempmainimg(null)
        setTempmainimginfo(null)
        setTempcroppedimg(null)
        setNeededit(false)
    }

    const uploadtobackend = async (data) => {

        const { token } = Retrieve_personal_info()
        const { img, thumbnail, urlhandler, id, heroimgarrposition, selectedtemplatetype, selectedlayout } = data

        const obj = await getPresignedUrlWithTokens(token, INVITATION_GETIMGUPLOADTOKENS);

        await Promise.all([
            uploadToS3(img, obj.uploadURL_key_arr[0].uploadURL),
            uploadToS3(thumbnail, obj.uploadURL_key_arr[1].uploadURL)
        ]);

        const img_link = obj.uploadURL_key_arr[0]['key']
        const thumbnail_link = obj.uploadURL_key_arr[1]['key']

        const bodydata = {
            img: img_link,
            thumbnail: thumbnail_link,
            urlhandler,
            id,
            heroimgarrposition,
            selectedtemplatetype,
            selectedlayout
        }

        const { message, loc } = await notifyBackendUpload(token, bodydata, INVITATION_SAVEHEROIMGS);

        if (message === 'SUCCESS') {
            updateheroimgobj(thumbnail_link, img_link, heroimgarrposition, selectedlayout, selectedtemplatetype)
            // bug
            setStatus('Uploading ' + tempmainimginfo['name'][0])

            setTimeout(() => {
                setTempmainimg(null)
                setTempmainimginfo(null)
                setTempcroppedimg(null)
                setStatus('')
                setNeededit(false)
                setUploadstate('WAITING')
            }, 1000)

            if (showsave) {
                setShowsave(false)
            }
        }
        else if (message === 'INCORRECTFILETYPE') {
            setStatus('Incorrect File Type.')
            setTimeout(() => { setStatus('') }, 1000)
        }
        else if (message === 'NOSUCHIC') {
            setStatus('Invitation Does Not Exist.')
            setTimeout(() => { setStatus('') }, 1000)
        }
        else if (message === 'REACHQUOTA') {
            setStatus('Reach Max Quota.')
            setTimeout(() => { setStatus('') }, 1000)
        }

    }

    const updateAnimationmode = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }

        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['mode'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateAnimatingspeed = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }

        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['speed'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateColor = (c) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['color'] = c
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateThickness = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['sw'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updatePosition = (e) => {
        if (!showsave) { setShowsave(true); updateBackup(); }
        const { value } = e.target
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['svgposition'] = parseInt(value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateSvganimation = (value) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] = value
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateReplay = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['svgoverlay_map']['replay'] = !new_heroimgattr_map[templatetype]['svgoverlay_map']['replay']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateBoxshadow = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['css_map']['boxShadow'] = !new_heroimgattr_map[templatetype]['css_map']['boxShadow']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateCorner = () => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['css_map']['borderRadius'] = !new_heroimgattr_map[templatetype]['css_map']['borderRadius']
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateWebimgconstant = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['css_map']['webimgconstant'] = Number(e.target.value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const updateTabletimgconstant = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true) }
        let new_heroimgattr_map = JSON.parse(JSON.stringify(heroimgattr_map))
        new_heroimgattr_map[templatetype]['css_map']['tabletimgconstant'] = Number(e.target.value)
        updateHeroimgattrmap(new_heroimgattr_map)
    }

    const MAIN_IMAGES_STYLE_DOM = <div className='Ieditcomp_div' style={{ ...homeimageeffectstyle_commoneditstyle, border: '1px solid var(--lightdark)', marginTop: 10, borderRadius: 10, backgroundColor: '#fffbfc', height: 'max-content', overflow: 'hidden' }}>

        {/* Animated Layer */}
        <div className="Details_grp">
            {partialtitle_dom('Animated Layer', {})}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <button
                    value={0}
                    onClick={() => updateSvganimation(0)}
                    className={`Images_firstsvg ${heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 0 ? 'Images_borderselected' : ''}`}
                    style={{
                        borderBottom: heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 1
                            ? 'none'
                            : heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 0
                                ? '3px solid var(--mainpink)'
                                : '1px solid var(--subgrey)'
                    }}
                >
                    <div className="Images_svgtxt">Empty</div>
                </button>
                <button
                    value={1}
                    onClick={() => updateSvganimation(1)}
                    className={`Images_midsvg ${heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 1 ? 'Images_borderselected' : ''}`}
                    style={{
                        borderTop: heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 0
                            ? 'none'
                            : heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 1
                                ? '3px solid var(--mainpink)'
                                : 'none',
                        borderBottom: heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 2
                            ? 'none'
                            : heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 1
                                ? '3px solid var(--mainpink)'
                                : 'none',
                    }}
                >
                    <svg className='Images_svgitem' width="100%" height="100%" viewBox="0 0 5030 1032" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {WEDO_PATH}
                    </svg>
                    <div className="Images_svgtxt">We Do</div>
                </button>
                <button
                    value={2}
                    onClick={() => updateSvganimation(2)}
                    className={`Images_secondsvg ${heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 2 ? 'Images_borderselected' : ''}`}
                    style={{
                        borderTop: heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 1
                            ? 'none'
                            : heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] === 2
                                ? '3px solid var(--mainpink)'
                                : '1px solid var(--subgrey)'
                    }}
                >
                    <svg className='Images_svgitem' width="100%" height="100%" viewBox="0 0 5030 1032" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        {HEART_PATH}
                    </svg>
                    <div className="Images_svgtxt">Heart</div>
                </button>

            </div>
        </div>

        {heroimgattr_map[templatetype]['svgoverlay_map']['svgitem'] !== 0
            ? <>
                {/* Animated Text Color */}
                <div className="Details_grp">
                    {partialtitle_dom('Animated Text Color', {})}
                    {inputdescribe_dom(`Color of animated text. `)}
                    <div className='Detailsfont_container'>
                        <div className='Detailsfont_left'>
                            <HexColorPicker style={{ height: 200, width: 200 }} color={heroimgattr_map[templatetype]['svgoverlay_map']['color']} onChange={updateColor} />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center' }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput color={heroimgattr_map[templatetype]['svgoverlay_map']['color']} onChange={updateColor} style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }} />
                            </div>
                        </div>
                        <ul className='Detailsfont_right'>
                            {colors_arr.map((c, i) => {
                                return <div key={i + 'color1'} style={{ padding: 1, width: 'max-content', height: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', border: heroimgattr_map[templatetype]['svgoverlay_map']['color'] === c ? '3px solid var(--mainpink)' : '3px solid transparent', borderRadius: 5 }}>
                                    <li style={{ width: 20, height: 20, backgroundColor: c, border: 'none', cursor: 'pointer', borderRadius: 3, border: heroimgattr_map[templatetype]['svgoverlay_map']['color'] === c ? 'none' : '1px solid var(--lightdark)' }} onClick={() => updateColor(c)} />
                                </div>
                            })}
                        </ul>
                    </div>
                </div>

                {/* Animated Text Animation Mode */}

                <div className="Details_grp">
                    {partialtitle_dom('Animated Text Animation Mode', {})}
                    {inputdescribe_dom(`Animation state of animated text.`)}
                    {(templatetype && heroimglayout)
                        ? threebtn_dom(
                            <>Static</>,
                            <>Entrance Animation</>,
                            <>Infinite Animation</>,
                            0, 1, 2,
                            heroimgattr_map[templatetype]['svgoverlay_map']['mode'],
                            updateAnimationmode,
                            { height: 50, width: 100, textTransform: 'capitalize' }
                        )
                        : null}
                </div>

                {/* Animating speed */}
                <div className="Details_grp">
                    {partialtitle_dom('Animating speed ', {})}
                    {inputdescribe_dom(`Speed of animating text`)}
                    {threebtn_dom(
                        <>Slow</>,
                        <>Medium</>,
                        <>Fast</>,
                        0, 1, 2,
                        heroimgattr_map[templatetype]['svgoverlay_map']['speed'],
                        updateAnimatingspeed,
                        { height: 40, width: 100, textTransform: 'capitalize' }
                    )}
                </div>

                {/* Animated Text Thickness */}
                <div className="Details_grp">
                    {partialtitle_dom('Animated Text Thickness', {})}
                    {inputdescribe_dom(`Select the thickness level of animated text.`)}
                    {threebtn_dom(
                        <>Thin</>,
                        <>Thick</>,
                        <>Thicker</>,
                        15, 30, 45,
                        heroimgattr_map[templatetype]['svgoverlay_map']['sw'],
                        updateThickness,
                        { height: 40, width: 100, textTransform: 'capitalize' }
                    )}
                </div>

                {/* Animated Text Position */}
                <div className="Details_grp">
                    {partialtitle_dom('Animated Text Position', {})}
                    {inputdescribe_dom(`Position of animated text.`)}
                    {threebtn_dom(
                        <>Top</>,
                        <>Center</>,
                        <>Bottom</>,
                        0, 1, 2,
                        heroimgattr_map[templatetype]['svgoverlay_map']['svgposition'],
                        updatePosition,
                        { height: 40, width: 100, textTransform: 'capitalize' }
                    )}
                </div>

                {/* Replay Button */}
                {heroimgattr_map[templatetype]['svgoverlay_map']['mode'] === 0 || heroimgattr_map[templatetype]['svgoverlay_map']['mode'] === 1
                    ? null
                    : <div className='Details_grp'>
                        {partialtitle_dom('Replay Button', {})}
                        {inputdescribe_dom(`On to allow user to replay animated text vice versa. Only available on "Infinite" mode.`)}
                        {radiobtn_dom(
                            heroimgattr_map[templatetype]['svgoverlay_map']['replay'] ? true : false,
                            updateReplay,
                            heroimgattr_map[templatetype]['svgoverlay_map']['replay'] ? `Replay Enabled` : `Replay Disabled`,
                            { margin: 0 }
                        )}
                    </div>
                }

            </>
            : null}



        {/* Box-shadow for Main Image */}
        {templatetype === 0
            ? <div className='Details_grp'>
                {partialtitle_dom('Box-shadow for Main Image', {})}
                {inputdescribe_dom(`On box-shadow for your main image vice versa`)}
                {radiobtn_dom(
                    heroimgattr_map[templatetype]['css_map']['boxShadow'] ? true : false,
                    updateBoxshadow,
                    heroimgattr_map[templatetype]['css_map']['boxShadow'] ? `Box-shadow Enabled` : `Box-shadow Disabled`,
                    { margin: 0 }
                )}
            </div>
            : null}

        {/* Corner for main image */}
        {templatetype === 0
            ? <div className='Details_grp'>
                {partialtitle_dom('Corner for main image', {})}
                {inputdescribe_dom(`Select type of corner for your image`)}
                {radiobtn_dom(
                    heroimgattr_map[templatetype]['css_map']['borderRadius'] ? true : false,
                    updateCorner,
                    heroimgattr_map[templatetype]['css_map']['borderRadius'] ? `Round Corner Enabled` : `Round Corner Disabled`,
                    { margin: 0 }
                )}
            </div>
            : null}

        {/* Image Size */}
        {templatetype === 1
            ? <div className='Details_grp'>
                {partialtitle_dom('Image Size', {})}
                {inputdescribe_dom(`Adjust the image size based on different devices`)}
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                    <button
                        className={`Details_settingbtn ${selecteddevice === 0 ? 'Details_selectedbtn' : selecteddevice !== -1 ? 'Details_selectednone' : ''}`}
                        value={0}
                        onClick={(e) => { setSelecteddevice(parseInt(e.target.value)) }}
                    >
                        {iconwrapper(LAPTOP_ICON, { width: 27, height: 27, })}
                        <div>Desktop</div>
                    </button>
                    <button
                        className={`Details_settingbtn ${selecteddevice === 1 ? 'Details_selectedbtn' : selecteddevice !== -1 ? 'Details_selectednone' : ''}`}
                        value={1}
                        onClick={(e) => { setSelecteddevice(parseInt(e.target.value)) }}
                    >
                        {iconwrapper(TABLET_ICON, { width: 27, height: 27, })}
                        <div>Tablet</div>
                    </button>
                </div>
                {[
                    // WEB
                    <div className='Details_lineacontainer' style={{ marginBottom: 0, padding: 10 }}>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['webimgconstant'] === 0.8 ? 'shaded' : ''}`}
                            value={0.8}
                            onClick={updateWebimgconstant}
                        >
                            Small
                        </button>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['webimgconstant'] === 0.9 ? 'shaded' : ''}`}
                            value={0.9}
                            onClick={updateWebimgconstant}
                        >
                            Medium
                        </button>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['webimgconstant'] === 1 ? 'shaded' : ''}`}
                            value={1}
                            onClick={updateWebimgconstant}
                        >
                            Large
                        </button>
                    </div>,
                    // TABLET
                    <div className='Details_lineacontainer' style={{ marginBottom: 0, padding: 10 }}>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['tabletimgconstant'] === 0.8 ? 'shaded' : ''}`}
                            value={0.8}
                            onClick={updateTabletimgconstant}
                        >
                            Small
                        </button>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['tabletimgconstant'] === 0.9 ? 'shaded' : ''}`}
                            value={0.9}
                            onClick={updateTabletimgconstant}
                        >
                            Medium
                        </button>
                        <button
                            className={`Images_sizebtn${heroimgattr_map[templatetype]['css_map']['tabletimgconstant'] === 1 ? 'shaded' : ''}`}
                            value={1}
                            onClick={updateTabletimgconstant}
                        >
                            Large
                        </button>
                    </div>
                ][selecteddevice]}
            </div>
            : null}

        {btmbar}

    </div>

    const MAIN_IMAGES_DOM = <div className='Ieditcomp_div'
        style={{
            height: {
                'WEB': 'calc(100% - 70px - 65px)',
                'TABLET': 'calc(100% - 70px - 65px)',
                'MOBILE': 'calc(100% - 70px)'
            }[device],
            marginBottom: {
                'MOBILE': 65
            }[device],
        }}>
        <Explain title={TITLE} txt={TEXT} />

        <div className='Details_grp'>
            {partialtitle_dom('Show/Hide Hero Image', {})}
            {inputdescribe_dom('Toggle visibility of the hero image on mobile ( the hero image on web/tablet is always on ).')}
            <div>
                <div className='ieditnavrow'>
                    {/* <div
                        className='Heroimages_deviceshowroot'
                        onClick={(e) => {
                            if (heroimglayout === e.target.value) return;
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            let local_heroimgdevice = JSON.parse(JSON.stringify(heroimgdevice_map))
                            local_heroimgdevice['WEB'] = !local_heroimgdevice['WEB']
                            updateHeroimgdevice(local_heroimgdevice)
                        }}
                    >
                        <label>Web/Tablet</label>
                        {heroimgdevice_map['WEB'] ? 'On' : 'Off'}
                    </div> */}
                    <div
                        className={`Heroimages_deviceshowroot_${heroimgdevice_map['MOBILE']}`}
                        onClick={(e) => {
                            if (heroimglayout === e.target.value) return;
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            let local_heroimgdevice = JSON.parse(JSON.stringify(heroimgdevice_map))
                            local_heroimgdevice['MOBILE'] = !local_heroimgdevice['MOBILE']
                            updateHeroimgdevice(local_heroimgdevice)
                        }}
                    >
                        <label>Mobile</label>
                        {heroimgdevice_map['MOBILE'] ? 'On' : 'Off'}
                    </div>
                </div>
            </div>
        </div>

        <div className='Details_grp'>
            {partialtitle_dom('Hero Image Layout', {})}
            {inputdescribe_dom('Image layout of your hero image')}
            <div>
                <div className='ieditnavrow'>
                    {(templatetype && heroimglayout)
                        ? threebtn_dom(
                            <>
                                {Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[0]}
                            </>,
                            <>
                                {Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[1]}
                            </>,
                            <>
                                {Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[2]}
                            </>,
                            Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[0], Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[1], Object.keys(ILOOKUPTEMPLATESINFO_MAP[templatetype])[2],
                            heroimglayout,
                            (e) => {
                                if (heroimglayout === e.target.value) return;
                                if (!showsave) { updateBackup(); setShowsave(true); }
                                updateHeroimglayout(e.target.value)
                            },
                            { height: 40, width: 100, textTransform: 'capitalize' }
                        )
                        : null}
                </div>
                <input
                    ref={imginputref}
                    accept="image/*"
                    className="Template_imginput"
                    id="formControlsFile"
                    type='file'
                    name="input-file"
                    onChange={async (e) => {
                        var reader = new FileReader()
                        let file = e.target.files[0]
                        reader.onload = (e) => {
                            var img = document.createElement("img");
                            img.onload = () => {
                                if (file.size < 20000000) { // 2MB : 2097152, 20MB : 20000000
                                    const { name, type } = file
                                    const width = img.naturalWidth;
                                    const height = img.naturalHeight;
                                    const aspectRatio = width / height;

                                    setTempmainimgaspectratio(aspectRatio)
                                    setTempmainimg([img.src])
                                    setTempmainimginfo(JSON.parse(JSON.stringify({ name: [name], type: [type] })))
                                    if (ILOOKUPTEMPLATESINFO_MAP[templatetype][heroimglayout]['img_edit'].neededit) {
                                        setNeededit(true) // activate Cropper
                                    }
                                }
                                else {
                                    setError(`Image size must be less than 10MB`);
                                    setTimeout(() => setError(''), 3000)
                                }
                            }
                            img.src = e.target.result;
                        }
                        reader.readAsDataURL(file);
                    }}
                />
            </div>

        </div>

        <div className='Details_grp'>
            {partialtitle_dom('Hero Images', {})}
            {inputdescribe_dom('The banner image that is first displayed to guests visiting your website.')}
            {templatetype
                ? {
                    'single': <Singlelayoutbtns
                        templatetype={templatetype}
                        heroimglayout_map={heroimglayout_map}
                        onClick={(e) => {
                            const { value } = e.target
                            setHeroimgarrposition(parseInt(value, 10))
                            imginputref.current.click()
                        }}
                        onDelete={(value) => {
                            setDeleteimgposition(value)
                            setCfmdel(true)
                        }}
                    />,
                    'marquee': <Marqueelayoutbtns
                        templatetype={templatetype}
                        heroimglayout_map={heroimglayout_map}
                        onClick={(e) => {
                            const { value } = e.target
                            setHeroimgarrposition(parseInt(value, 10))
                            imginputref.current.click()
                        }}
                        onDelete={(value) => {
                            setDeleteimgposition(value)
                            setCfmdel(true)
                        }}
                    />,
                    'slideshow': <Slideshowlayoutbtns
                        templatetype={templatetype}
                        heroimglayout_map={heroimglayout_map}
                        onClick={(e) => {
                            const { value } = e.target
                            setHeroimgarrposition(parseInt(value, 10))
                            imginputref.current.click()
                        }}
                        onDelete={(value) => {
                            setDeleteimgposition(value)
                            setCfmdel(true)
                        }}
                    />,
                }[heroimglayout]
                : null}

        </div>

        <div className='Details_grp'>
            {partialtitle_dom('Hero Image Effects & Style', {})}
            {inputdescribe_dom('Add stunning styles and effects to your hero image.')}
            {MAIN_IMAGES_STYLE_DOM}
        </div>
        {btmbar}

        {neededit
            ? <div className="Imageic_croproot">
                <div className="Imageic_cropcontainer">
                    <Cropper
                        image={tempmainimg}
                        crop={crop}
                        zoom={zoom}
                        aspect={
                            ILOOKUPTEMPLATESINFO_MAP[templatetype][heroimglayout]['img_edit']['aspectratio'] === 'BASED_ON_IMAGE'
                                ? tempmainaspectratio
                                : ILOOKUPTEMPLATESINFO_MAP[templatetype][heroimglayout]['img_edit']['aspectratio']
                        }
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={cropcomplete}
                    />
                    <div className="Imageic_btnsrow">
                        {uploadstate === 'WAITING'
                            ? <button key={'imgs_cancel_' + uploadstate} className="Imageic_btn" onClick={cropcancel}>
                                Cancel
                            </button>
                            : null}
                        {uploadstate === 'UPLOADING'
                            ? <div className="Imageic_uploading" >
                                ...
                            </div>
                            : null}
                        {uploadstate === 'WAITING'
                            ? <button key={'imgs_upload_' + uploadstate} onClick={editupload} className="Imageic_btn" style={{ marginRight: 5 }} disabled={uploadstate === 'UPLOADING'}>
                                Upload
                            </button>
                            : null}
                    </div>
                </div>
            </div>
            : null
        }


        {/* {neededit
            ? <div className="Imageic_croproot">
                <div className="Imageic_cropcontainer">
                    <Cropper
                        image={tempmainimg}
                        crop={crop}
                        zoom={zoom}
                        aspect={ILOOKUPTEMPLATESINFO_MAP[templatetype][heroimglayout]['img_edit']['aspectratio']} // can be landscape or portrait, depends on the templatetype and layout
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={cropcomplete}
                    />
                    <div className="Imageic_btnsrow">
                        {uploadstate === 'WAITING'
                            ? <button key={'imgs_cancel_' + uploadstate} className="Imageic_btn" onClick={cropcancel}>
                                Cancel
                            </button>
                            : null}
                        {uploadstate === 'UPLOADING'
                            ? <div className="Imageic_uploading" >
                                ...
                            </div>
                            : null}
                        {uploadstate === 'WAITING'
                            ? <button key={'imgs_upload_' + uploadstate} onClick={editupload} className="Imageic_btn" style={{ marginRight: 5 }} disabled={uploadstate === 'UPLOADING'}>
                                Upload
                            </button>
                            : null}
                    </div>
                </div>
            </div>
            : null
        } */}

        <Noti noti={status} />
        <Noti noti={error} />

        {cfmdel // for deleting image
            ? <Modcfm
                onHide={() => { setCfmdel(false) }}
                onOk={async () => {
                    setCfmdel(false)
                    delsingleheroimgobj(templatetype, heroimglayout, deleteimgposition)
                        .then((message) => {
                            const { result, msg } = message
                            if (result && msg === 'Saved') {
                                setDeleteimgposition(-1)
                            }
                        })
                        .catch(e => {
                            console.log('e', e)
                        })
                }}
                onNo={() => {
                    setCfmdel(false)
                }}
                txt={'Once you delete this, there is no going back. Please be certain.'}
            />
            : null}

        {showrmvmod
            ? <Modcfm
                onHide={() => { setShowrmvmod(false) }}
                onOk={() => { setShowrmvmod(false); setRmvcfm(true); }}
                onNo={() => { setShowrmvmod(false); setRmvcfm(false); setRmvindex(-1); }}
                txt={'Once you delete this, there is no going back. Please be certain.'}
            />
            : null}
    </div>

    return MAIN_IMAGES_DOM

}

export default Heroimages